import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import type {IconProp, SizeProp} from '@fortawesome/fontawesome-svg-core'

interface FaIconLibraryProps {
  icon?: IconProp
  size?: SizeProp
  text?: string | null
  showTextBefore?: boolean
  showTextAfter?: boolean
}

const FaIconLibrary = ({
  icon = 'check' as IconProp,
  size = 'sm' as SizeProp,
  text = null,
  showTextBefore = false,
  showTextAfter = false,
}: FaIconLibraryProps) => {
  if (showTextBefore && showTextAfter) showTextAfter = false
  let renderDOM = (
    <span className='icon'>
      <FontAwesomeIcon icon={icon} size={size} />
    </span>
  )
  if ((showTextBefore || showTextAfter) && text) {
    renderDOM = (
      <span
        className='icon-text'
        style={{
          flexWrap: 'nowrap',
          alignItems: 'center',
        }}
      >
        {showTextBefore && <span>{text}</span>}
        <span className='icon'>
          <FontAwesomeIcon icon={icon} size={size} />
        </span>
        {showTextAfter && <span>{text}</span>}
      </span>
    )
  }
  return renderDOM
}
export default FaIconLibrary
